<template>
  <div class="container-fluid">
    <!-- Modal Activate Card -->
    <div
      v-if="showFreezeCard === true"
      class="modal fade"
      id="activateConfirm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <p>Are You sure activate your card?</p>
            <a
              ><button
                v-if="isActivateCardButtonLoading === true"
                data-dismiss="modal"
                v-on:click="activateCard"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Activating card...
              </button>
              <button
                v-if="isActivateCardButtonLoading === false"
                data-dismiss="modal"
                v-on:click="activateCard"
              >
                Confirm and activate my card now
              </button>
            </a>
            <a
              ><button data-dismiss="modal" class="white">
                Cancel
              </button></a
            >
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Freeze Card -->
    <div
      v-if="showFreezeCard === true"
      class="modal fade"
      id="freezeConfirm"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="modal-body">
            <p>
              Freezing your card, suspends it from use<br />immediately so that
              it cannot be used.<br />You can reverse this at any time
            </p>
            <a
              ><button
                v-if="isFreezeCardButtonLoading === true"
                data-dismiss="modal"
                v-on:click="freezeCard"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Freezing card...
              </button>
              <button
                v-if="isFreezeCardButtonLoading === false"
                data-dismiss="modal"
                v-on:click="freezeCard"
              >
                Confirm and freeze my card now
              </button>
            </a>
            <a
              ><button data-dismiss="modal" class="white">
                Cancel
              </button></a
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8 profile">
        <!-- Without CMS -->
        <div v-if="isCmsUsed === false">
          <h2>Freeze card</h2>

          <p>
            You can freeze your card right here:
          </p>
        </div>
        <!-- With CMS -->
        <div v-if="isCmsUsed === true" v-html="leftContent"></div>

        <div v-if="showFreezeCard === true">
          <a class="margRight"
            ><button
              type="button"
              data-toggle="modal"
              data-target="#activateConfirm"
            >
              Activate
            </button></a
          ><a
            ><button
              type="button"
              data-toggle="modal"
              data-target="#freezeConfirm"
            >
              Freeze
            </button></a
          >
          <div class="spacer-60"></div>
        </div>
      </div>

      <div class="col-md-4 promos">
        <Promotions />
      </div>
      <div class="col-md-4 promos promos2">
        <Promotions />
      </div>
    </div>
    <Cards />
    <footer>
      <div class="row">
        <div class="col-md-12">
          <p>
            This website hosted at URL Bonusme.uk is provided by Performance
            Bonus Ltd a company registered in England and Wales (registration
            number 4326332) Registered Office: 2 St Mary Street, Chepstow,
            Monmouthshire, NP16 5EU. The Card and electronic money (‘e-money’)
            loaded on it are issued by Payment Card Solutions (UK) Limited
            trading as B4B Payments, a company registered in England and Wales
            (registration number 05941947) and registered office at 21-24
            Millbank, London, England, SW1P 4QP. Payment Card Solutions (UK)
            Limited is authorised and regulated in the UK by the Financial
            Conduct Authority (Firm Reference Number: 930619) for the issuing of
            e-money. Mastercard is a registered trademark, and the circles
            design is a trademark of Mastercard International Incorporated.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import Cards from "./Cards.vue";
import actions from "@/store/cards/actions";
import Promotions from "./Promotions.vue";
export default {
  components: {
    Cards,
    Promotions
  },
  created() {
    this.leftContent =
      this.isCmsUsed === true &&
      this.cmsPage != undefined &&
      this.cmsPage.leftContent != null
        ? this.cmsPage.leftContent
        : "";
    this.showFreezeCard =
      this.isCmsUsed === false ||
      (this.isCmsUsed === true &&
        this.cmsPage != undefined &&
        this.cmsPage.showFreezeCard === true);
  },
  computed: {
    isCmsUsed: {
      get() {
        return this.$store.state.cms.isCmsUsed;
      }
    },
    cmsPage: {
      get() {
        return this.$store.state.cms.cmsPage;
      }
    },
    cardGuid: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.user?.cardGuid;
      }
    },
    cardStatus: {
      get() {
        return this.$store.state.accounts.fullAccountDetails.card?.status ===
          "suspended"
          ? true
          : false;
      },
      set(value) {
        this.$store.commit("updateFreezeCardStatusMutation", value);
      }
    },
    isCardFrozen: {
      get() {
        return this.$store.state.cards.isCardFrozen;
      }
    },
    isFreezeCardButtonLoading: {
      get() {
        return this.$store.state.settings.isFreezeCardButtonLoading;
      },
      set(value) {
        this.$store.commit("updateIsFreezeCardButtonLoadingMutation", value);
      }
    },
    isActivateCardButtonLoading: {
      get() {
        return this.$store.state.settings.isActivateCardButtonLoading;
      },
      set(value) {
        this.$store.commit("updateIsActivateCardButtonLoadingMutation", value);
      }
    }
  },
  methods: {
    freezeCard: async function() {
      window.$("#freezeConfirm").modal("hide");
      this.isFreezeCardButtonLoading = true;
      await this.$store.dispatch(
        actions.PUT_CARD_STATUS_AS_FROZEN,
        this.cardGuid
      );
    },
    activateCard: async function() {
      window.$("#activateConfirm").modal("hide");
      this.isActivateCardButtonLoading = true;
      await this.$store.dispatch(
        actions.PUT_CARD_STATUS_AS_ACTIVE,
        this.cardGuid
      );
    }
    // changeCardStatus: async function() {
    //   if (this.isCardFrozen === true) {
    //     await this.$store.dispatch(
    //       actions.PUT_CARD_STATUS_AS_FROZEN,
    //       this.cardGuid
    //     );
    //   } else {
    //     await this.$store.dispatch(
    //       actions.PUT_CARD_STATUS_AS_ACTIVE,
    //       this.cardGuid
    //     );
    //   }
    // }
  }
};
</script>
